<template>
  <div class="finance-enroll-fee-import"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="main-cont">
      <div class="batch-select">
        <span class="custom-label">招生批次</span>
        <el-select v-model="selectedBatchId"
                   size="mini"
                   filterable
                   placeholder="请选择招生批次">
          <el-option v-for="batch in batchList"
                     :key="batch.id"
                     :label="batch.name"
                     :value="batch.id"></el-option>
        </el-select>
      </div>
      <DataImportModule v-if="selectedBatchId"
                        :key="selectedBatchId"
                        import-url="/workspace/manager/finance/enrollFeeManage/importPayRecord"
                        :extra-params="importParams"
                        :pre-handle-verify="verifyBatchSelected"
                        inline
                        @dataImportSuccess="handleImportSuccess">
        <span slot="external">
          <el-button size="mini"
                     @click="handleClose">关闭窗口</el-button>
        </span>
      </DataImportModule>
      <div v-else-if="!loading"
           class="empty-tip">请先选择招生批次后再导入</div>
    </div>
  </div>
</template>

<script>
import DataImportModule from '../../../../../../elements/DataImportModule'

export default {
  name: 'FinanceEnrollFeeImportPayRecord',
  components: {
    DataImportModule
  },
  props: {
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      selectedBatchId: '',
      batchList: []
    }
  },
  computed: {
    importParams () {
      return {
        batchId: this.selectedBatchId
      }
    }
  },
  methods: {
    getDefaultBatchId (batchList) {
      if (!batchList.length) {
        return ''
      }
      const currentBatch = batchList.find(batch => batch.current)
      return (currentBatch || batchList[0]).id
    },
    loadBatchList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/finance/enrollFeeManage/enrollBatchList',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data.responseCode) {
            case 'SUCCESS': {
              this.batchList = response.data.batchList || []
              this.selectedBatchId = this.getDefaultBatchId(this.batchList)
              break
            }
            default: {
              this.batchList = []
              this.selectedBatchId = ''
              this.$message.warning(response.data.message)
              break
            }
          }
        }
      }, () => {
        this.batchList = []
        this.selectedBatchId = ''
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    verifyBatchSelected () {
      if (!this.selectedBatchId) {
        this.$message.warning('请选择招生批次后再导入')
        return false
      }
      return true
    },
    handleClose () {
      this.$emit('hidePopover')
    },
    handleImportSuccess () {
      this.$emit('hidePopoverAndRefresh')
    }
  },
  mounted () {
    this.loadBatchList()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadBatchList()
      }
    }
  }
}
</script>

<style lang="scss">
.finance-enroll-fee-import {
  min-height: 520px;
  background-color: #fff;
  & > .main-cont {
    padding: 15px;
    .batch-select {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
        color: #606266;
      }
      .el-select {
        width: 260px;
      }
    }
    .empty-tip {
      height: 450px;
      border: 1px dashed #dcdfe6;
      font-size: 13px;
      line-height: 450px;
      text-align: center;
      color: #909399;
      background-color: #fafafa;
    }
  }
}
</style>
